import React from "react";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-6 py-20 grid gap-12 md:grid-cols-2 lg:grid-cols-5">

        {/* BRAND */}
        <div className="lg:col-span-2">
          <h3 className="text-white text-xl font-semibold mb-4">
            TechX Incorporation
          </h3>
          <p className="text-gray-400 max-w-md leading-relaxed">
            Enterprise corporate training and technology consulting firm helping
            organizations scale engineering capabilities and deliver
            production-grade technology solutions globally.
          </p>
        </div>

        {/* TRAINING */}
        <div>
          <h4 className="text-white font-semibold mb-4">
            Training
          </h4>
          <ul className="space-y-3">
            <li>Corporate Training Programs</li>
            <li>Technology Upskilling</li>
            <li>Cloud & Data Training</li>
            <li>AI & Enterprise Systems</li>
          </ul>
        </div>

        {/* SOLUTIONS */}
        <div>
          <h4 className="text-white font-semibold mb-4">
            Solutions
          </h4>
          <ul className="space-y-3">
            <li>Enterprise IT Solutions</li>
            <li>Cloud & Data Platforms</li>
            <li>AI & Intelligent Systems</li>
            <li>Consulting & Advisory</li>
          </ul>
        </div>

        {/* COMPANY */}
        <div>
          <h4 className="text-white font-semibold mb-4">
            Company
          </h4>
          <ul className="space-y-3">
            <li>About Us</li>
            <li>Clients</li>
            <li>Careers</li>
            <li>Contact</li>
          </ul>
        </div>
      </div>

      {/* BOTTOM BAR */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row gap-4 md:justify-between md:items-center text-sm text-gray-400">
          <span>
            © {new Date().getFullYear()} TechX Incorporation. All rights reserved.
          </span>
          <div className="flex gap-6">
            <span>Privacy Policy</span>
            <span>Terms of Use</span>
            <span>finance@techxincorporation.com</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
